import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Container, Box } from '@mui/material';

import { AuthProvider } from './context/AuthContext';

import Navbar from './components/layout/Navbar';
import ProtectedRoute from './components/layout/ProtectedRoute';
import Login from './components/auth/Login';
import Dashboard from './components/dashboard/Dashboard';
import SourceSystems from './components/admin/SourceSystems';
import MongoBrowser from './components/admin/MongoBrowser';

import theme from './theme';
import './App.css';

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <AuthProvider>
                <Router>
                    <Navbar />
                    <Box component="main" sx={{ py: 3 }}>
                        <Container maxWidth="lg">
                            <Routes>
                                <Route path="/login" element={<Login />} />

                                <Route element={<ProtectedRoute />}>
                                    <Route path="/dashboard" element={<Dashboard />} />
                                    <Route path="/source-systems" element={<SourceSystems />} />
                                    <Route path="/database-browser" element={<MongoBrowser />} />
                                </Route>

                                <Route path="*" element={<Navigate to="/dashboard" />} />
                            </Routes>
                        </Container>
                    </Box>
                </Router>
            </AuthProvider>
        </ThemeProvider>
    );
}

export default App;